<template>
  <img src="/s-images/icons/payment-systems/sbp.svg" alt="SBP" class="icon-sbp" />
</template>

<script>
  export default {
    name: 'IconSBP',
  }
</script>

<style scoped lang="less">
.icon-sbp {
  width: 90px;
}
</style>
